/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { featuresEntryPoint } from '@jira/portfolio-3__plan-features/src/featuresEntryPoint.entrypoint.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlanSettingsFeaturesEntryPointEntrypointProps } from './PlanSettingsFeaturesEntryPoint.entrypoint.types.tsx';

type NestedEntryPoints = {
	// The below is required to fix an type error in the entrypoint that only appears in the CI. It's a known issue with nested entrypoints.
	// https://atlassian.slack.com/archives/C07JUC8ALCT/p1741233995361509?thread_ts=1741215074.681649&cid=C07JUC8ALCT
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	preLoadFeaturesEntryPoint: any;
};

type PlanSettingsFeaturesEntryPointComponent = EntryPointComponent<
	{},
	NestedEntryPoints,
	PlanSettingsFeaturesEntryPointEntrypointProps,
	{}
>;

export const planSettingsFeaturesEntryPoint: EntryPoint<
	PlanSettingsFeaturesEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<PlanSettingsFeaturesEntryPointComponent>(
		/* webpackChunkName: "async-plan-settings-features-entrypoint" */ './PlanSettingsFeatures.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (entryPointParams: EntryPointRouteParams) => {
		return {
			entryPoints: {
				preLoadFeaturesEntryPoint: {
					entryPoint: featuresEntryPoint,
					entryPointParams,
				},
			},
		};
	},
});
